import { render, staticRenderFns } from "./epmallitemdesc.vue?vue&type=template&id=1590ff3f"
import script from "./epmallitemdesc.vue?vue&type=script&lang=js"
export * from "./epmallitemdesc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports